const reasons = [
  { icon: "ri-checkbox-circle-line", title: "Built From Real Experience", desc: "Our systems are built from real operational experience, not assumptions." },
  { icon: "ri-checkbox-circle-line", title: "Outcome-Focused", desc: "We focus on outcomes, not just features." },
  { icon: "ri-checkbox-circle-line", title: "Built for Africa", desc: "We understand the realities of African businesses." },
  { icon: "ri-checkbox-circle-line", title: "Scalable & Modular", desc: "We provide scalable, modular solutions that grow with you." },
  { icon: "ri-checkbox-circle-line", title: "Structure & Flexibility", desc: "We deliver both structure and flexibility in every deployment." },
];

export default function WhyChooseSection() {
  return (
    <section className="py-16 md:py-24 bg-graphite-900">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-graphite-700 bg-graphite-800/50 mb-6">
              <span className="text-xs font-medium text-silver-300 tracking-wide">Why StackMap</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">Why Organizations Choose StackMap</h2>
            <p className="text-base md:text-lg text-silver-300 max-w-2xl mx-auto leading-relaxed">
              We are not a features list. We are a partner in building operational structure.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {reasons.map((r) => (
              <div key={r.title} className="glass-card p-6 md:p-7 flex flex-col gap-3 group">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-accent/10 group-hover:bg-emerald-accent/20 transition-colors duration-300">
                  <i className={`${r.icon} text-xl text-emerald-accent`}></i>
                </div>
                <h3 className="text-base md:text-lg font-bold text-white group-hover:text-emerald-soft transition-colors duration-300">{r.title}</h3>
                <p className="text-sm text-silver-400 leading-relaxed">{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
